import React from "react";
import { Link } from "react-router-dom";

const PageHeader = () => {
  return (
    <>
      <div className="page-header">
        <h1>
          <button
            className="btn_5 mt05 float-end"
            data-bs-toggle="modal"
            data-bs-target="#addSkillSet"
          >
            Skills Mapping
          </button>
          Skills Mapping
        </h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to={"/dashboard"}>Dashboard</Link>
          </li>
          <li className="current">
            <span>/</span> Manage Skill Mapping
          </li>
        </ul>
      </div>
    </>
  );
};

export default PageHeader;